__turbopack_context__.v({
  "applyButton": "style-module-scss-module__JdP1PW__applyButton",
  "closeButton": "style-module-scss-module__JdP1PW__closeButton",
  "drawer-content": "style-module-scss-module__JdP1PW__drawer-content",
  "drawerHeader": "style-module-scss-module__JdP1PW__drawerHeader",
  "drawerPaper": "style-module-scss-module__JdP1PW__drawerPaper",
  "filterLabel": "style-module-scss-module__JdP1PW__filterLabel",
  "filterSection": "style-module-scss-module__JdP1PW__filterSection",
  "filterSections": "style-module-scss-module__JdP1PW__filterSections",
  "filtersTitle": "style-module-scss-module__JdP1PW__filtersTitle",
});
